import { useCallback, useEffect } from "react";
import { signOut as apiSignOut } from "api/signOut";
import { useAuthenticatedUserContext } from "context/AuthenticatedUserContext";

export const useAuthenticatedUser = () => {
	const {
		state: { user, isLoggedIn, error, loading, loginDetails },
		actions: { loadUser, clearUser }
	} = useAuthenticatedUserContext();

	const signOut = useCallback(async () => {
		try {
			await apiSignOut();
		} catch (_error) {
			/* We are okay with sign out fail, might mean the user is already signed out */
		} finally {
			clearUser();
			window.location.reload();
		}
	}, [clearUser]);

	useEffect(() => {
		if (!user && !error) {
			const url = new URL(window.location.href);
			const provider = url.searchParams.get("provider") as "okta" | "microsoft" | "google" | undefined;
			const method = url.searchParams.get("method") as "saml" | "oidc" | undefined;
			void loadUser(provider && method ? { method, provider } : undefined);
			url.searchParams.delete("provider");
			url.searchParams.delete("method");
			window.history.replaceState({}, "", url.toString());
		}
	}, [error, loadUser, loginDetails, user]);

	return {
		signOut,
		reloadUser: loadUser,
		error,
		loading,
		isLoggedIn,
		loginDetails,
		user
	};
};
